// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"hzKuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _chord = require("./Chord");
parcelHelpers.exportAll(_chord, exports);
var _interval = require("./Interval");
parcelHelpers.exportAll(_interval, exports);
var _mode = require("./Mode");
parcelHelpers.exportAll(_mode, exports);
var _note = require("./Note");
parcelHelpers.exportAll(_note, exports);
var _scale = require("./Scale");
parcelHelpers.exportAll(_scale, exports);
var _parseChord = require("./parseChord");
parcelHelpers.exportAll(_parseChord, exports);

},{"./Chord":"dozQF","./Interval":"iMSdS","./Mode":"bRbTs","./Note":"ciakO","./Scale":"1zlNR","./parseChord":"ig02I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dozQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chord", ()=>Chord);
var _interval = require("./Interval");
var _note = require("./Note");
class Chord {
    constructor(step, type){
        this.type = type;
        this.typeLabel = Chord.labelFromType(type);
        if (type === "maj7") {
            const notes = (0, _interval.Interval).notesFromIndexOctaveAndType(step, 0, "maj");
            const min = (0, _interval.Interval).notesFromIndexOctaveAndType((0, _note.Note).notationIndex(notes[1].notation), notes[1].octave, "min");
            this.initializeFromNotes(notes.concat(min[2]));
        } else if (type === "min7") {
            const notes = (0, _interval.Interval).notesFromIndexOctaveAndType(step, 0, "min");
            const min = (0, _interval.Interval).notesFromIndexOctaveAndType((0, _note.Note).notationIndex(notes[1].notation), notes[1].octave, "min");
            this.initializeFromNotes(notes.concat(min[2]));
        } else if (type === "dom7") {
            const notes = (0, _interval.Interval).notesFromIndexOctaveAndType(step, 0, "maj");
            const dim = (0, _interval.Interval).notesFromIndexOctaveAndType((0, _note.Note).notationIndex(notes[1].notation), notes[1].octave, "dim");
            this.initializeFromNotes(notes.concat(dim[2]));
        } else this.initializeFromNotes((0, _interval.Interval).notesFromIndexOctaveAndType(step, 0, type));
    }
    initializeFromNotes(notes) {
        this.label = notes[0].notation + this.typeLabel;
        this.notation = notes[0].notation;
        this.key = Chord.keyFromNotations(notes.map(({ notation })=>notation));
        this.notes = notes;
    }
    static keyFromNotations(notations) {
        return notations.sort().join("-");
    }
    static labelFromType(type) {
        switch(type){
            case "maj":
                return "";
            case "min":
                return "m";
            case "min7":
                return "m7";
            case "maj7":
                return "M7";
            case "aug":
                return "+";
            case "dim":
                return "\xb0";
            case "dom7":
                return "7";
        }
    }
    static get types() {
        return [
            "maj",
            "min",
            "maj7",
            "min7",
            "dom7",
            "aug",
            "dim"
        ];
    }
}

},{"./Interval":"iMSdS","./Note":"ciakO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iMSdS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Interval", ()=>Interval);
var _note = require("./Note");
class Interval {
    constructor(step, offset, type){
        const index = offset % (0, _note.Note).notations.length;
        const octave = offset > (0, _note.Note).notations.length - 1 ? 1 : 0;
        const notation = (0, _note.Note).notations[index];
        const alternate = (0, _note.Note).notationsAlternate[index];
        this.label = `${notation} ${type}`;
        this.notation = notation;
        this.notationAlternate = alternate === notation ? undefined : alternate;
        this.notes = Interval.notesFromIndexOctaveAndType(index, octave, type);
        this.octave = octave;
        this.step = step;
        this.meta = {
            name: Interval.nameFromType(type),
            numeral: Interval.numeralFromType(step, type),
            type
        };
    }
    static intervalsFromModeType(mode) {
        switch(mode){
            case "melodic":
                return [
                    "min",
                    "min",
                    "aug",
                    "maj",
                    "maj",
                    "dim",
                    "dim"
                ];
            case "harmonic":
                return [
                    "min",
                    "dim",
                    "aug",
                    "min",
                    "maj",
                    "maj",
                    "dim"
                ];
        }
    }
    static intervalsFromOffset(offset) {
        // this is ionian, each mode bumps up one offset.
        const base = [
            "maj",
            "min",
            "min",
            "maj",
            "maj",
            "min",
            "dim"
        ];
        const triads = [];
        for(let i = 0; i < base.length; i++)triads.push(base[(i + offset) % base.length]);
        return triads;
    }
    static nameFromType(type) {
        switch(type){
            case "maj":
                return "Major";
            case "min":
                return "Minor";
            case "aug":
                return "Augmented";
            case "dim":
                return "Diminished";
        }
    }
    static numeralFromType(step, type) {
        const notation = [
            "i",
            "ii",
            "iii",
            "iv",
            "v",
            "vi",
            "vii"
        ][step];
        switch(type){
            case "maj":
                return notation.toUpperCase();
            case "min":
                return notation;
            case "aug":
                return `${notation.toUpperCase()}+`;
            case "dim":
                return `${notation}\xb0`;
        }
    }
    static notesFromIndexOctaveAndType(offset, octave, type) {
        // get the steps for this chord type
        const steps = {
            maj: [
                0,
                4,
                7
            ],
            min: [
                0,
                3,
                7
            ],
            dim: [
                0,
                3,
                6
            ],
            aug: [
                0,
                4,
                8
            ]
        }[type];
        const notes = [];
        const roots = (0, _note.Note).notations;
        for(let i = 0; i < steps.length; i++){
            const step = steps[i];
            const idx = (offset + step) % roots.length;
            // relative octave to base
            const relative = offset + step > roots.length - 1 ? octave + 1 : octave;
            // define the note
            notes.push({
                notation: roots[idx],
                octave: relative
            });
        }
        return notes;
    }
}

},{"./Note":"ciakO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ciakO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Note", ()=>Note);
class Note {
    constructor({ octave, step }){
        const notation = Note.notations[step];
        const alternate = Note.notationsAlternate[step];
        this.frequency = Note.octaveStepFrequencies[octave][step];
        this.id = Note.noteIdFromNotationAndOctave(notation, octave);
        this.index = step + octave * 12;
        this.notation = notation;
        this.notationAlternate = alternate === this.notation ? undefined : alternate;
        this.octave = octave;
        this.octaveIndex = step;
    }
    static notationIndex(notation) {
        const notationsIndex = Note.notations.indexOf(notation);
        if (notationsIndex !== -1) return notationsIndex;
        const notationsAlternateIndex = Note.notationsAlternate.indexOf(notation);
        if (notationsAlternateIndex !== -1) return notationsAlternateIndex;
        return -1;
    }
    static noteIdFromNotationAndOctave(notation, octave) {
        return `${notation}${octave}`;
    }
    static get notations() {
        return [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ];
    }
    static get notationsAlternate() {
        return [
            "C",
            "Db",
            "D",
            "Eb",
            "E",
            "F",
            "Gb",
            "G",
            "Ab",
            "A",
            "Bb",
            "B"
        ];
    }
    static get notationsUnique() {
        return Array.from(new Set([
            ...Note.notations,
            ...Note.notationsAlternate
        ]));
    }
    // prettier-ignore
    static get octaveStepFrequencies() {
        return {
            0: {
                0: 16.352,
                1: 17.324,
                2: 18.354,
                3: 19.445,
                4: 20.602,
                5: 21.827,
                6: 23.125,
                7: 24.5,
                8: 25.957,
                9: 27.5,
                10: 29.135,
                11: 30.868
            },
            1: {
                0: 32.703,
                1: 34.648,
                2: 36.708,
                3: 38.891,
                4: 41.203,
                5: 43.654,
                6: 46.249,
                7: 48.999,
                8: 51.913,
                9: 55,
                10: 58.27,
                11: 61.735
            },
            2: {
                0: 65.406,
                1: 69.296,
                2: 73.416,
                3: 77.782,
                4: 82.407,
                5: 87.307,
                6: 92.499,
                7: 97.999,
                8: 103.826,
                9: 110,
                10: 116.541,
                11: 123.471
            },
            3: {
                0: 130.813,
                1: 138.591,
                2: 146.832,
                3: 155.563,
                4: 164.814,
                5: 174.614,
                6: 184.997,
                7: 195.998,
                8: 207.652,
                9: 220,
                10: 233.082,
                11: 246.942
            },
            4: {
                0: 261.626,
                1: 277.183,
                2: 293.665,
                3: 311.127,
                4: 329.628,
                5: 349.228,
                6: 369.994,
                7: 391.995,
                8: 415.305,
                9: 440,
                10: 466.164,
                11: 493.883
            },
            5: {
                0: 523.251,
                1: 554.365,
                2: 587.33,
                3: 622.254,
                4: 659.255,
                5: 698.456,
                6: 739.989,
                7: 783.991,
                8: 830.609,
                9: 880,
                10: 932.328,
                11: 987.767
            },
            6: {
                0: 1046.502,
                1: 1108.731,
                2: 1174.659,
                3: 1244.508,
                4: 1318.51,
                5: 1396.913,
                6: 1479.978,
                7: 1567.982,
                8: 1661.219,
                9: 1760,
                10: 1864.655,
                11: 1975.533
            },
            7: {
                0: 2093.005,
                1: 2217.461,
                2: 2349.318,
                3: 2489.016,
                4: 2637.02,
                5: 2793.826,
                6: 2959.955,
                7: 3135.963,
                8: 3322.438,
                9: 3520,
                10: 3729.31,
                11: 3951.066
            },
            8: {
                0: 4186.01,
                1: 4434.92,
                2: 4698.63,
                3: 4978.03,
                4: 5274.04,
                5: 5587.65,
                6: 5919.91,
                7: 6271.93,
                8: 6644.88,
                9: 7040,
                10: 7458.62,
                11: 7902.13
            }
        };
    }
    static stringIsNotation(string) {
        return Note.notations.includes(string) || Note.notationsAlternate.includes(string);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bRbTs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mode", ()=>Mode);
var _interval = require("./Interval");
class Mode {
    constructor({ type }){
        this.type = type;
        this.name = Mode.nameFromType(type);
        this.steps = Mode.stepsFromType(type);
        this.intervals = Mode.intervalsFromType(type);
    }
    static get types() {
        return [
            "ionian",
            "dorian",
            "phrygian",
            "lydian",
            "mixolydian",
            "aeolian",
            "locrian",
            "melodic",
            "harmonic",
            "major",
            "minor"
        ];
    }
    static intervalsFromType(type) {
        switch(type){
            case "major":
            case "ionian":
                return (0, _interval.Interval).intervalsFromOffset(0);
            case "dorian":
                return (0, _interval.Interval).intervalsFromOffset(1);
            case "phrygian":
                return (0, _interval.Interval).intervalsFromOffset(2);
            case "lydian":
                return (0, _interval.Interval).intervalsFromOffset(3);
            case "mixolydian":
                return (0, _interval.Interval).intervalsFromOffset(4);
            case "minor":
            case "aeolian":
                return (0, _interval.Interval).intervalsFromOffset(5);
            case "locrian":
                return (0, _interval.Interval).intervalsFromOffset(6);
            case "melodic":
                return (0, _interval.Interval).intervalsFromModeType("melodic");
            case "harmonic":
                return (0, _interval.Interval).intervalsFromModeType("harmonic");
        }
    }
    static nameFromType(type) {
        switch(type){
            case "major":
            case "ionian":
                return "Ionian";
            case "dorian":
                return "Dorian";
            case "phrygian":
                return "Phrygian";
            case "lydian":
                return "Lydian";
            case "mixolydian":
                return "Mixolydian";
            case "minor":
            case "aeolian":
                return "Aeolian";
            case "locrian":
                return "Locrian";
            case "melodic":
                return "Melodic Minor";
            case "harmonic":
                return "Harmonic Minor";
        }
    }
    static stepsFromType(type) {
        switch(type){
            case "major":
            case "ionian":
                return Mode.stepsFromIncrements([
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    1
                ]);
            case "dorian":
                return Mode.stepsFromIncrements([
                    2,
                    1,
                    2,
                    2,
                    2,
                    1,
                    2
                ]);
            case "phrygian":
                return Mode.stepsFromIncrements([
                    1,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2
                ]);
            case "lydian":
                return Mode.stepsFromIncrements([
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    1
                ]);
            case "mixolydian":
                return Mode.stepsFromIncrements([
                    2,
                    2,
                    1,
                    2,
                    2,
                    1,
                    2
                ]);
            case "minor":
            case "aeolian":
                return Mode.stepsFromIncrements([
                    2,
                    1,
                    2,
                    2,
                    1,
                    2,
                    2
                ]);
            case "locrian":
                return Mode.stepsFromIncrements([
                    1,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2
                ]);
            case "melodic":
                return Mode.stepsFromIncrements([
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    1
                ]);
            case "harmonic":
                return Mode.stepsFromIncrements([
                    2,
                    1,
                    2,
                    2,
                    1,
                    3,
                    1
                ]);
        }
    }
    static stepsFromIncrements(increments) {
        const steps = [
            0
        ];
        let step = 0;
        for(let i = 0; i < increments.length - 1; i++){
            step += increments[i];
            steps.push(step);
        }
        return steps;
    }
    static stringIsModeType(string) {
        return Mode.types.includes(string);
    }
}

},{"./Interval":"iMSdS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zlNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OCTAVES", ()=>OCTAVES);
parcelHelpers.export(exports, "STEPS", ()=>STEPS);
parcelHelpers.export(exports, "Scale", ()=>Scale);
var _interval = require("./Interval");
var _mode = require("./Mode");
var _note = require("./Note");
const OCTAVES = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8
];
const STEPS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11
];
class Scale {
    constructor(params){
        /**
   * Library of all notes
   */ this.library = Scale.buildLibrary();
        this.root = params.root;
        this.label = "";
        this.intervals = [];
        this.noteIds = [];
        this.mode = new (0, _mode.Mode)({
            type: params.mode
        });
        this.root = params.root;
        this.rootOffset = (0, _note.Note).notationIndex(params.root);
        this.update(params);
    }
    update({ root, mode }) {
        this.mode = new (0, _mode.Mode)({
            type: mode
        });
        this.root = root;
        this.rootOffset = (0, _note.Note).notationIndex(root);
        this.label = `${root} ${this.mode.name}`;
        this.intervals = this.mode.steps.map((step, index)=>new (0, _interval.Interval)(index, this.rootOffset + step, this.mode.intervals[index]));
        this.noteIds = [];
        const lastOctave = OCTAVES[OCTAVES.length - 1];
        OCTAVES.forEach((mainOctave)=>{
            this.intervals.forEach(({ notation, octave })=>{
                const relOctave = octave + mainOctave;
                if (relOctave <= lastOctave) this.noteIds.push((0, _note.Note).noteIdFromNotationAndOctave(notation, relOctave));
            });
        });
    }
    static buildLibrary() {
        return OCTAVES.reduce((library, octave)=>{
            STEPS.forEach((step)=>{
                const note = new (0, _note.Note)({
                    octave,
                    step
                });
                library[note.id] = note;
            });
            return library;
        }, {});
    }
    /**
   * Array of playable notes in the scale.
   */ get notes() {
        return this.noteIds.map((noteId)=>this.library[noteId]);
    }
}

},{"./Interval":"iMSdS","./Mode":"bRbTs","./Note":"ciakO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ig02I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Find the `Chord` whose notes are exactly this set, if there is one.
 *
 * An augmented triad is symmetric under transposition — C, E and G# augmented
 * are the same three pitch classes — so the root is taken to be the first note
 * written rather than guessed.
 */ parcelHelpers.export(exports, "chordFromPitchClasses", ()=>chordFromPitchClasses);
/**
 * Parse concatenated note letters into pitch classes.
 *
 *   parseChord("CEG")  // [0, 4, 7], recognized as C major
 *   parseChord("ACBb") // [9, 0, 10], no chord
 *   parseChord("CG")   // [0, 7], no chord
 *
 * Each note is a letter A–G with an optional `#` or `b`. Quality suffixes are
 * deliberately not accepted: "Cm" and "C7" throw rather than parse, because
 * the notation here spells out every note it means. Construct a `Chord`
 * directly if you want to name a quality instead of spelling it.
 *
 * Duplicates collapse to their first occurrence, so order carries meaning —
 * the first note written is the root.
 */ parcelHelpers.export(exports, "parseChord", ()=>parseChord);
var _chord = require("./Chord");
var _note = require("./Note");
/**
 * Spellings outside `Notation` and `NotationAlternate`.
 *
 * Note carries the twelve sharps and the five common flats, which is every
 * name you need to describe a pitch. These four are the ones you only reach
 * for when the key signature demands them — Cb in G flat major, E# in F sharp
 * major. They are real names for real notes, so the parser accepts them, but
 * they do not deserve a place in the Notation union.
 */ const THEORETICAL_NOTATIONS = {
    Cb: 11,
    "B#": 0,
    Fb: 4,
    "E#": 5
};
/** Semitones above the root for each chord quality. */ const CHORD_INTERVALS = {
    maj: [
        0,
        4,
        7
    ],
    min: [
        0,
        3,
        7
    ],
    maj7: [
        0,
        4,
        7,
        11
    ],
    min7: [
        0,
        3,
        7,
        10
    ],
    dom7: [
        0,
        4,
        7,
        10
    ],
    aug: [
        0,
        4,
        8
    ],
    dim: [
        0,
        3,
        6
    ]
};
function pitchClassFromName(name) {
    const index = (0, _note.Note).notationIndex(name);
    if (index !== -1) return index;
    return THEORETICAL_NOTATIONS[name];
}
function chordFromPitchClasses(pitchClasses) {
    const unique = Array.from(new Set(pitchClasses));
    for (const root of unique)for (const type of (0, _chord.Chord).types){
        const intervals = CHORD_INTERVALS[type];
        if (intervals.length !== unique.length) continue;
        const expected = intervals.map((step)=>(root + step) % 12);
        if (expected.every((pitchClass)=>unique.includes(pitchClass))) return new (0, _chord.Chord)(root, type);
    }
    return undefined;
}
function parseChord(letters) {
    const trimmed = letters.trim();
    if (!trimmed) throw new Error(`Empty chord: "${letters}"`);
    const seen = new Set();
    const pitchClasses = [];
    const notations = [];
    let position = 0;
    while(position < trimmed.length){
        const letter = trimmed[position];
        if (!/[A-G]/.test(letter)) throw new Error(`Unexpected character "${letter}" in chord "${letters}" (position ${position}). Use letters A\u{2013}G with optional # or b.`);
        let name = letter;
        position++;
        const accidental = trimmed[position];
        if (accidental === "#" || accidental === "b") {
            name += accidental;
            position++;
        }
        const pitchClass = pitchClassFromName(name);
        if (pitchClass === undefined) throw new Error(`Unknown note "${name}" in chord "${letters}"`);
        if (!seen.has(pitchClass)) {
            seen.add(pitchClass);
            pitchClasses.push(pitchClass);
            notations.push((0, _note.Note).notations[pitchClass]);
        }
    }
    if (pitchClasses.length === 0) throw new Error(`No notes in chord: "${letters}"`);
    return {
        pitchClasses,
        notations,
        label: trimmed,
        chord: chordFromPitchClasses(pitchClasses)
    };
}

},{"./Chord":"dozQF","./Note":"ciakO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},[], null, "parcelRequire4648", {})

//# sourceMappingURL=music-detection.7ab572f5.js.map
